<template>
	<el-tabs>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;">
				<Biaodan v-model="value.shu" :ming="Anniu"></Biaodan>
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<div class="big_box" v-if="value.yangshi" style="margin-top: 10px;">
				<el-input v-model="value.yangshi.width" placeholder="px"> <template slot="prepend">宽度</template></el-input>
				<el-input v-model="value.yangshi.height" placeholder="px"> <template slot="prepend">高度</template></el-input>
				<el-input v-model="value.yangshi.text_align" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
			</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Biaodan from '../Biaodan.vue'
	export default {
		name: 'anniu_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},
		components: {
			Biaodan
		},
	}
</script>
<link rel="stylesheet" href="Yangshi.css">
